import React, { useCallback, useContext, useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, useIntl } from "react-intl"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { RadioGroupWithTileStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupWithTileStep"
import { useFlags } from "launchdarkly-react-client-sdk"

const pelvicFloorOptions = [
  {
    label: defineMessage({ defaultMessage: "Yes" }),
    value: "YES"
  },
  {
    label: defineMessage({ defaultMessage: "No" }),
    value: "NO"
  }
]

export function RelatedToPelvicFloorStep(): JSX.Element | null {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { isPelvicFloor }
  } = useContext(CarrotCardCostSharePreAuthContext)
  const { pelvicFloorTherapyReimbursementLaunched } = useFlags()

  const formattedOptions = useConvertTranslatedLabel(pelvicFloorOptions) as FormSelectOption[]

  useEffect(() => {
    if (!pelvicFloorTherapyReimbursementLaunched) {
      send("NO")
    }
  }, [pelvicFloorTherapyReimbursementLaunched, send])

  const onSubmit = useCallback(
    (formValues: { [key: string]: string }): void => {
      dispatchFormState({ type: "UPDATE_FIELD", field: "isPelvicFloor", value: formValues.isPelvicFloor })
      send(formValues.isPelvicFloor)
    },
    [dispatchFormState, send]
  )

  if (!pelvicFloorTherapyReimbursementLaunched) {
    return null
  }

  return (
    <RadioGroupWithTileStep
      title={intl.formatMessage({ defaultMessage: "Is this related to pelvic floor physical therapy?" })}
      name="isPelvicFloor"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={isPelvicFloor}
    >
      {null}
    </RadioGroupWithTileStep>
  )
}
